import React from 'react';
import { useNavigate } from 'react-router-dom'
import CurrencyValue from 'ui-component/CurrencyValue';
import usePermissions from 'hooks/usePermissions';
import useIsMobile from 'utils/isMobileUtils';


const PurchaseOrderComponent = ({ details }) => {
    const [allPermissions, hasEveryPermission] = usePermissions();
    const history = useNavigate();
    const isMobile = useIsMobile();

    const handleOpenNewTab = (pageModule, id) => {
        let url = '';
        if (pageModule == 'products') {
            url = `/products/${id}`;
        } else if (pageModule == 'contacts') {
            url = `/contacts/${id}`;
        } else if (pageModule == 'purchase_orders') {
            url = `/purchasing/view/${id}`;
        } else if (pageModule == 'sales_orders') {
            url = `/sales/sales-orders/${id}`;
        }
        if (url) {
            history(url);
        }
    };

    return (
        !isMobile ? (
            <div style={{ padding: '0px 20px 20px 16px' }}>
                <div className="row mb10">
                    <div className="col-12">
                        <h2 className="d-flex font600" style={{ fontSize: '18px' }}>Purchase Orders</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2 font600">PO #</div>
                    <div className="col-md-4 font600">Product</div>
                    <div className="col-md-1 font600">Qty</div>
                    <div className="col-md-2 font600">Price</div>
                    <div className="col-md-3 font600">Profit</div>
                </div>
                <hr className="mt8 mb8" />
                {details?.map((order, index) => (
                    <React.Fragment key={order?.id || index}>
                        {order?.items?.map((orderItem, i) => (
                            <React.Fragment key={orderItem?.id || i}>
                                <div className="row">
                                    <div className="col-md-2 ">
                                        <div
                                            className={`${hasEveryPermission(['View Purchase Order']) ? 'text-primary cursor-pointer' : ''}`}
                                            onClick={() => {
                                                if (hasEveryPermission(['View Purchase Order'])) {
                                                    handleOpenNewTab('purchase_orders', order?.id)
                                                }
                                            }}
                                        >
                                            {order?.purchase_order_id}
                                        </div>
                                    </div>
                                    <div className="col-md-4 ">
                                        <div
                                            className={`${hasEveryPermission(['View Product (Button)']) ? 'text-primary cursor-pointer' : ''}`}
                                            onClick={() => {
                                                if (hasEveryPermission(['View Product (Button)'])) {
                                                    handleOpenNewTab('products', orderItem?.product?.id)
                                                }
                                            }}
                                        >
                                            {orderItem?.product?.name}
                                        </div>
                                        <div
                                            style={{ fontSize: '11px' }}
                                            className={`${hasEveryPermission(['View Contact (Button)']) ? 'textGray cursor-pointer' : 'textGray'}`}
                                            onClick={() => {
                                                if (hasEveryPermission(['View Contact (Button)'])) {
                                                    handleOpenNewTab('contacts', orderItem?.supplier?.id)
                                                }
                                            }}
                                        >
                                            {orderItem?.supplier?.name}
                                        </div>
                                    </div>
                                    <div className="col-md-1">{orderItem?.item_qty}</div>
                                    <div className="col-md-2 ">
                                        <CurrencyValue
                                            currencyObject={orderItem?.unit_price}
                                            defaultCurrency={order?.currency}
                                        />
                                    </div>
                                    <div className="col-md-3 ">
                                        <div className="row">
                                            <div className="col-12 d-flex" style={{ gap: '25px' }}>
                                                <div className="textGray">Total</div>
                                                <div>
                                                    <CurrencyValue
                                                        currencyObject={orderItem?.gross_total}
                                                        defaultCurrency={order?.currency}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 d-flex" style={{ gap: '20px' }}>
                                                <div className="textGray">Gross</div>
                                                <div>
                                                    <CurrencyValue
                                                        currencyObject={orderItem?.gross_profit}
                                                        defaultCurrency={order?.currency}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 d-flex" style={{ gap: '6px' }}>
                                                <div className="textGray">Gross %</div>
                                                <div>(${orderItem?.gross_profit_percentage}%)</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className="mt8 mb8" />
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                ))}
            </div>
        ) : (
            // --- MOBILE VERSION LIKE SALESORDER ---
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h2 className="d-flex font600" style={{ fontSize: '18px', borderBottom: '1px solid #e0e0e0', paddingBottom: 10, marginBottom: 0 }}>Purchase Orders</h2>
                {details?.map((order, index) => (
                    <React.Fragment key={order?.id || index}>
                        {order?.items?.map((orderItem, i) => (
                            <div
                                key={orderItem?.id || i}
                                style={{
                                    borderBottom: '1px solid #eee',
                                    paddingTop: 12,
                                    paddingBottom: 12,
                                    background: '#fff'
                                }}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                    <div style={{ fontWeight: 600 }}>
                                        PO #:
                                        <span
                                            className={`${hasEveryPermission(['View Purchase Order']) ? 'text-primary cursor-pointer' : ''}`}
                                            onClick={() => {
                                                if (hasEveryPermission(['View Purchase Order'])) {
                                                    handleOpenNewTab('purchase_orders', order?.id)
                                                }
                                            }}
                                            style={{ marginLeft: 6 }}
                                        >
                                            {order?.purchase_order_id}
                                        </span>
                                    </div>
                                    <div style={{ fontWeight: 500 }}>
                                        Qty: {orderItem?.item_qty}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                    <div
                                        className={`${hasEveryPermission(['View Product (Button)']) ? 'text-primary cursor-pointer' : ''}`}
                                        onClick={() => {
                                            if (hasEveryPermission(['View Product (Button)'])) {
                                                handleOpenNewTab('products', orderItem?.product?.id)
                                            }
                                        }}
                                        style={{ fontWeight: 500, fontSize: 14 }}
                                    >
                                        {orderItem?.product?.name}
                                    </div>
                                    <div style={{ fontWeight: 500 }}>
                                        <CurrencyValue
                                            currencyObject={orderItem?.unit_price}
                                            defaultCurrency={order?.currency}
                                        />
                                    </div>
                                </div>
                                <div
                                    style={{
                                        fontSize: 12,
                                        color: '#888',
                                        marginBottom: 8,
                                        cursor: hasEveryPermission(['View Contact (Button)']) ? 'pointer' : 'default'
                                    }}
                                    onClick={() => {
                                        if (hasEveryPermission(['View Contact (Button)'])) {
                                            handleOpenNewTab('contacts', orderItem?.supplier?.id)
                                        }
                                    }}
                                >
                                    {orderItem?.supplier?.name}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>
                                        <div className="textGray">Total</div>
                                        <CurrencyValue
                                            currencyObject={orderItem?.gross_total}
                                            defaultCurrency={order?.currency}
                                        />
                                    </div>
                                    <div>
                                        <div className="textGray">Gross</div>
                                        <CurrencyValue
                                            currencyObject={orderItem?.gross_profit}
                                            defaultCurrency={order?.currency}
                                        />
                                    </div>
                                    <div>
                                        <div className="textGray">Gross %</div>
                                        <div>(${orderItem?.gross_profit_percentage}%)</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </React.Fragment>
                ))}
            </div>
        )
    );
};

export default PurchaseOrderComponent;
